import React from 'react';
import { Range, getTrackBackground } from 'react-range';
import { Box, Stack, Typography } from '@mui/material';

type AnalyticThresholdProps = {
    setExperienceValue: (value: number[]) => void,
    skillValue: number[],
    setSkillValue: (value: number[]) => void,
    experienceValue: number[],
    expTitle: string,
    skillTitle: string,
}

export const AnalyticThreshold = ({
  setExperienceValue,
  skillValue,
  setSkillValue,
  experienceValue,
  expTitle,
  skillTitle,
}: AnalyticThresholdProps) => {

  return (
    <Stack spacing={1} sx={{ fontSize: '13.5px', mt: 7, width: 250, mr: 5 }}>
      <Typography
        component="output"
        id="output"
        sx={{ mt: 3, fontSize: 'inherit' }}
      >
        {skillTitle} ({skillValue[0]} - {skillValue[1]})
      </Typography>
      <Range
        values={skillValue}
        step={1}
        min={0}
        max={40}
        onChange={(newValues) => setSkillValue(newValues)}
        renderTrack={({ props, children }) => (
          <Box
            {...props}
            sx={{
              height: 6,
              width: '100%',
              alignSelf: 'center',
              borderRadius: '3px',
            }}
            style={{
              ...props.style,
              background: getTrackBackground({
                values: skillValue,
                colors: ['#ccc', '#548BF4', '#ccc'],
                min: 0,
                max: 40,
              }),
            }}
          >
            {children}
          </Box>
        )}
        renderThumb={({ props, isDragged }) => (
          <Box
            {...props}
            sx={{
              height: 24,
              width: 24,
              borderRadius: '50%',
              bgcolor: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            }}
            style={props.style}
          >
            <Box
              sx={{
                height: 16,
                width: 4,
                bgcolor: isDragged ? '#3b82f6' : '#d1d5db',
                borderRadius: '1px',
              }}
            />
          </Box>
        )}
      />

      <Typography
        component="output"
        id="output"
        sx={{ mt: 3, fontSize: 'inherit' }}
      >
        {expTitle} ({experienceValue[0]} - {experienceValue[1]})
      </Typography>
      <Range
        values={experienceValue}
        step={1}
        min={0}
        max={40}
        onChange={(newValues) => setExperienceValue(newValues)}
        renderTrack={({ props, children }) => (
          <Box
            {...props}
            sx={{
              height: 6,
              width: '100%',
              alignSelf: 'center',
              borderRadius: '3px',
            }}
            style={{
              ...props.style,
              background: getTrackBackground({
                values: experienceValue,
                colors: ['#ccc', '#548BF4', '#ccc'],
                min: 0,
                max: 40,
              }),
            }}
          >
            {children}
          </Box>
        )}
        renderThumb={({ props, isDragged }) => (
          <Box
            {...props}
            sx={{
              height: 24,
              width: 24,
              borderRadius: '50%',
              bgcolor: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            }}
            style={props.style}
          >
            <Box
              sx={{
                height: 16,
                width: 4,
                bgcolor: isDragged ? '#3b82f6' : '#d1d5db',
                borderRadius: '1px',
              }}
            />
          </Box>
        )}
      />
    </Stack>
  );
};
